import { useCallback } from 'react';
import { axiosInstance } from '../utils';
import { PRESENCE_STATUS } from '../constants/presence';
import { useDispatch, useSelector } from 'react-redux';

export const usePresence = () => {
  const presenceSlice = useSelector((state) => state?.['__global/presence']?.data);
  const presenceData = transformPresenceFromAPI(presenceSlice);
  const dispatch = useDispatch();
  const updatePresence = useCallback((newPresence) => {
    axiosInstance.post('/presence-service/v1/user/setting', newPresence).then((res) => {
      dispatch(setPresenceAction(res.data));
    });
  }, []);

  return {
    presenceFromAPI: presenceData,
    updatePresence,
  };
};

function setPresenceAction(data) {
  return { type: '__global_PRESENCE_SUCCESS', data };
}
function transformPresenceFromAPI(presenceSlice) {
  const isAutomatic = PRESENCE_STATUS.AUTOMATIC === presenceSlice?.userSettingStatus;

  return {
    isAutomatic,
    status: presenceSlice?.status,
    userSettingStatus: presenceSlice?.userSettingStatus,
    message: presenceSlice?.customMessage,
    expiresAtDateTime:
      presenceSlice?.status === PRESENCE_STATUS.DO_NOT_DISTURB && presenceSlice?.userSettingStatusExpiresAt,
  };
}
